export default function HeroSection() {
  return (
    <section data-testid="hero-section" className="relative pt-16 pb-10 px-6 max-w-[820px] mx-auto">
      <div className="hero-glow" />

      <div
        className="inline-block mb-5 px-4 py-1.5 rounded-sm font-mono text-[11px] tracking-wide"
        style={{
          background: "var(--sdb-surface)",
          border: "1px solid var(--sdb-border)",
          color: "var(--sdb-text-muted)",
        }}
      >
        Built for AI developers
      </div>

      <h1
        className="text-4xl sm:text-5xl lg:text-6xl font-semibold tracking-tight leading-[1.08] mb-5"
        style={{ color: "var(--sdb-text)" }}
      >
        Generate a Mock Database Instantly{" "}
        <span className="gradient-text">with realistic, industry-specific data.</span>
      </h1>

      <p
        className="text-base md:text-lg leading-relaxed max-w-[600px] mb-10"
        style={{ color: "var(--sdb-text-secondary)" }}
      >
        Generic toy data kills AI demos. Generate relationally complex, domain-accurate databases
        that mirror your client's industry. Build, test, and sell your AI application with data
        your prospects actually recognize.
      </p>

      <div className="flex justify-start gap-8 flex-wrap">
        {[
          { n: "5+", l: "Relational Tables" },
          { n: "1,000+", l: "Rows per DB" },
          { n: "~15s", l: "Generation Time" },
          { n: "50+", l: "Industries Covered" },
        ].map((s, i) => (
          <div key={i} className="text-left">
            <div className="font-mono text-xl font-bold" style={{ color: "var(--sdb-accent)" }}>
              {s.n}
            </div>
            <div
              className="text-[10px] mt-0.5 font-mono uppercase tracking-wider"
              style={{ color: "var(--sdb-text-muted)" }}
            >
              {s.l}
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
